const getItemWidth = (container) => (itemCount) => container.scrollWidth / itemCount;
export const scrollBy = (container) => (itemCount, delta) => {
    container.scrollBy({ left: delta * getItemWidth(container)(itemCount), behavior: 'smooth' });
};
//# sourceMappingURL=scrollBy.js.map